// Date helpers for the history sidebar and headers (local time zone).

const DAY = 24 * 60 * 60 * 1000

function startOfDay(ts) {
  const d = new Date(ts)
  d.setHours(0, 0, 0, 0)
  return d.getTime()
}

/** "Today" | "Yesterday" | "Last 7 days" | "Last 30 days" | "Month Year" */
export function historyGroup(ts, now = Date.now()) {
  const today = startOfDay(now)
  if (ts >= today) return 'Today'
  if (ts >= today - DAY) return 'Yesterday'
  if (ts >= today - 7 * DAY) return 'Last 7 days'
  if (ts >= today - 30 * DAY) return 'Last 30 days'
  return new Date(ts).toLocaleDateString(undefined, { month: 'long', year: 'numeric' })
}

/** Items (sorted newest first) → [{ label, items }] preserving order. */
export function groupByDay(items, getTime, now = Date.now()) {
  const groups = []
  for (const item of items) {
    const label = historyGroup(getTime(item), now)
    const last = groups[groups.length - 1]
    if (last?.label === label) last.items.push(item)
    else groups.push({ label, items: [item] })
  }
  return groups
}

/** "Today", "Yesterday", "Mon 22 Sep" */
export function dayLabel(ts, now = Date.now()) {
  if (!ts) return 'Today'
  const today = startOfDay(now)
  if (ts >= today) return 'Today'
  if (ts >= today - DAY) return 'Yesterday'
  return new Date(ts).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' })
}

/** "28 Sep 2026" */
export function formatDate(ts) {
  if (!ts) return ''
  return new Date(ts).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function formatRelative(ts, now = Date.now()) {
  if (!ts) return ''
  const diff = Math.max(0, now - ts)
  if (diff < 60_000) return 'just now'
  if (diff < 3_600_000) return `${Math.round(diff / 60_000)} min ago`
  if (diff < DAY) return `${Math.round(diff / 3_600_000)} h ago`
  return formatDate(ts)
}
